import React from "react";
import PropTypes from "prop-types";
import { Message } from "@qgiv/core-donor";
import * as messageLocations from "../../common/AccountForm/constants/messageLocations";
import "./ReceiptMessage.scss";

const ReceiptMessage = ({
    submittedMessage,
    updateRegistrationAccountSubmittedMessage,
}) => {
    const hasSubmittedMessage = Object.keys(submittedMessage).length > 0;

    // Confirm that there is a message before extracting the message data
    if (hasSubmittedMessage) {
        const { location, message, type } = submittedMessage;
        const messageProp = {
            closeButton: true,
            absolutePosition: false,
            type,
            message,
        };

        // And render the message if it was intended for the receipt header
        if (location === messageLocations.RECEIPT_HEADER) {
            return (
                <div className="receipt-message">
                    <div className="receipt-message__container-absolute">
                        <div className="col col--12">
                            <Message
                                message={messageProp}
                                // A required function that resets
                                // state.registrationAccount.form.submittedMessage
                                // to an empty object when a user clicks the
                                // close message button
                                setMessage={
                                    updateRegistrationAccountSubmittedMessage
                                }
                            />
                        </div>
                    </div>
                </div>
            );
        }
    }

    return null;
};

ReceiptMessage.propTypes = {
    // submittedMessage can either be an empty object or an object with a
    // specific shape
    submittedMessage: PropTypes.shape({
        location: PropTypes.string,
        message: PropTypes.arrayOf(PropTypes.string),
        type: PropTypes.string,
    }).isRequired,
    updateRegistrationAccountSubmittedMessage: PropTypes.func.isRequired,
};

export default ReceiptMessage;
